import { Stack, Col } from 'rsuite';
import classNames from 'classnames';
import MenuIcon from '@rsuite/icons/Menu';
import { HomeElms, host, server } from '../config/const';
import { useAppSelector, useAppDispatch } from '@monorepo/shared';
import {
  Brand,
  OUTree,
  NoticeSpeaker,
  UserProfile,
  LocaleSelector,
  SupportDropdown,
  ServiceDropdown
} from '@monorepo/shared/components';
import logImg from '../images/header/FAZ_cloud.svg';
import { useGetCommonDataQuery } from '@monorepo/shared/services/globalApi';
import {
  isExpanded,
  updateExpanded
} from '@monorepo/shared/store/sidemenuSlice';
import { useLocation, useNavigate } from 'react-router-dom';
import { CSSProperties, useEffect, useState } from 'react';
import {
  selectNotices,
  selectRetentions
} from '@monorepo/shared/store/authSlice';
import {
  selectAccountWithPermission,
  selectLoginSaml,
  selectSystem
} from '@monorepo/shared/store/accountSlice';
import { selectOU } from '@monorepo/shared/store/fcOuSlice';
import './Header.scss';
interface IProps {
  hideSideMenu?: boolean;
  style?: CSSProperties;
}

const Header = ({ hideSideMenu, style }: IProps) => {
  const { pathname } = useLocation();
  const loginSaml = useAppSelector(selectLoginSaml);
  const systemData = useAppSelector(selectSystem);
  const ouData = useAppSelector(selectOU);
  const notices = useAppSelector(selectNotices);
  const retentions = useAppSelector(selectRetentions);
  const account = useAppSelector(selectAccountWithPermission);
  const commonData = useGetCommonDataQuery({ server: server });
  const menuExpanded = useAppSelector(isExpanded);
  const logoIcon = (
    <img src={logImg} width="46px" style={{ marginRight: '8px' }}></img>
  );
  const logoClasses = classNames('left-container', {
    expand: menuExpanded
  });
  const dispatch = useAppDispatch();

  return (
    <div
      className="frame-header"
      style={{
        ...style,
        justifyContent: 'space-between',
        alignItems: 'center'
      }}
    >
      <div className={logoClasses} style={{ height: '100%' }}>
        <Stack alignItems="center" style={{ height: '100%' }} spacing={30}>
          {!hideSideMenu && (
            <MenuIcon
              onClick={() => dispatch(updateExpanded(!menuExpanded))}
              style={{ cursor: 'pointer' }}
            />
          )}
          <Brand
            logo={logoIcon}
            title={HomeElms.name}
            subtitle={'Cloud'}
            isExpanded={true}
            titleStyle={{
              fontWight: 'blod',
              fontSize: '1.2rem',
              color: '#212121'
            }}
            subTitleStyle={{
              fontWight: 'blod',
              fontSize: '1.2rem',
              paddingLeft: '8px',
              color: '#212121'
            }}
          />
          {account?.portals?.some(
            (item: Record<string, any>) => item?.visibility !== 'Hide'
          ) && (
            <ServiceDropdown commonData={commonData?.data} account={account} />
          )}
          {account?.support_menu?.some(
            (item: Record<string, any>) => item?.visibility !== 'Hide'
          ) && (
            <SupportDropdown commonData={commonData?.data} account={account} />
          )}
        </Stack>
      </div>
      <Col className="right-container">
        <Stack
          spacing={20}
          justifyContent="flex-end"
          style={{ height: '100%' }}
        >
          {systemData?.i18n_support && (
            <Stack.Item style={{ width: '150px' }}>
              <LocaleSelector host={host} />
            </Stack.Item>
          )}

          <NoticeSpeaker notices={notices} retentions={retentions} />

          {!pathname.includes('cred') &&
          ouData?.length &&
          account?.permission_scope?.node_type !== 'Account' ? (
            <OUTree hasPermissionScope />
          ) : (
            <></>
          )}

          <UserProfile
            account={account}
            loginSaml={loginSaml}
            commonData={commonData?.data}
          />
        </Stack>
      </Col>
    </div>
  );
};

export default Header;
